import type { Config } from "tailwindcss";

const tailwindTheme = {
  extend: {
    colors: {
      coral: {
        "05": "#FAF6F4",
        10: "#FBE8D9",
        20: "#FCDAC4",
        30: "#FDCBB2",
        40: "#FFBCA3",
        50: "#EFA185",
        60: "#BE715C",
        70: "#8F4236",
        80: "#640030",
      },
      dawn: {
        "05": "#FFFBEE",
        10: "#FFF5D8",
        20: "#FFEDC3",
        30: "#FFDEA4",
        40: "#FFCD85",
        50: "#FFAE3D",
        60: "#DB6D00",
        70: "#AF4715",
        80: "#4E0E0E",
      },
      dusk: {
        "05": "#F7F5FE",
        10: "#E3DEFD",
        15: "#EFD5D4",
        20: "#CFC7FC",
        30: "#A695FB",
        40: "#7E64FB",
        50: "#5532FA",
        60: "#4428CE",
        70: "#331EA4",
        80: "#24157B",
      },
      ember: {
        "05": "#FEF1EF",
        10: "#FCDCDB",
        20: "#FFBDBB",
        30: "#FF9691",
        40: "#FB716C",
        50: "#F24646",
        60: "#C13536",
        70: "#912525",
        80: "#601415",
      },
      eucalyptus: {
        "05": "#F0F7F5",
        10: "#E0EEEA",
        20: "#D0E6E0",
        30: "#C0DDD6",
        40: "#8FBEB6",
        50: "#609F9A",
        60: "#3C7E81",
        70: "#215E68",
        80: "#07404E",
      },
      fern: {
        "05": "#EBF9F3",
        10: "#D4F0E3",
        20: "#B0E3CB",
        30: "#7CD0A6",
        40: "#50C087",
        50: "#00B066",
        60: "#01864E",
        70: "#00693D",
        80: "#004528",
      },
      fog: {
        "00": "#FFFFFF",
        "05": "#FBFAF9",
        10: "#F7F6F5",
        15: "#EEEDEC",
        20: "#E5E4E3",
        30: "#C3C2C1",
        40: "#A6A5A4",
        50: "#777675",
        60: "#535251",
        70: "#292827",
        80: "#191817",
      },
      midnight: {
        "05": "#F5F8FF",
        10: "#E6EFFF",
        20: "#BCD3FC",
        30: "#94B6FB",
        40: "#6F9BF8",
        50: "#3477F3",
        60: "#0D54D7",
        70: "#003699",
        80: "#150A45",
      },
    },
    maxWidth: {
      container: "1240px",
    },
    height: {
      "navbar-lg": "68px", // Default height
      navbar: "56px", // Default height
      banner: "56px",
      "mobile-cta": "90px",
    },
    margin: {
      "navbar-lg": "68px", // Default height
      navbar: "56px", // Default height
      banner: "56px",
      "mobile-cta": "90px",
    },
    inset: {
      "navbar-lg": "68px", // Default height
      navbar: "56px", // Default height
      banner: "56px",
      "mobile-cta": "90px",
    },
    backgroundImage: () => ({
      "gradient-23": "linear-gradient(23deg, var(--tw-gradient-stops))",
    }),
    boxShadow: {
      "mobile-mobile-cta": "0px -2px 6px 0px rgba(25, 24, 23, 0.06)",
    },
  },
  fontFamily: {
    primary: ["TT Norms Pro", "TTNormsPro", "sans-serif"],
  },
  screens: {
    xl: "1320px",
    lg: "1024px",
    md: "768px",
    sm: "576px",
    xs: "375px",
  },
  animation: {
    fade: "fadeIn .45s ease-in-out",
    "slide-in": "slide-in .45s cubic-bezier(.57,.14,.34,.94)",
    "right-to-left-slide-in": "right-to-left-slide-in .2s cubic-bezier(.57,.14,.34,.94)",
  },

  keyframes: {
    "right-to-left-slide-in": {
      "0%": {
        transform: "translateX(100%)",
      },
      "100%": {
        transform: "translate(0)",
      },
    },
    "slide-in": {
      "0%": {
        opacity: "0",
        transform: "translate(20px)",
      },
      "50%": {
        opacity: "0",
        transform: "translate(20px)",
      },
      "100%": {
        opacity: "1",
        transform: "translate(0px)",
      },
    },
    fadeIn: {
      from: { opacity: "0" },
      to: { opacity: "1" },
    },
  },
};

export default {
  content: [
    // Or if using `src` directory:
    "./src/**/*.{js,ts,jsx,tsx,mdx}",
  ],
  theme: tailwindTheme,
  plugins: [],
} satisfies Config;
